export default __webpack_public_path__ + "static/media/406.99ae05fb.jpg";